<template>
  <div class="home-charts-container">

    <cards-page-filters
      v-model="filters"
      :hidden="['search', 'stages', 'negotiations', 'my_turn', 'my', 'export_cards']"
      @change=""
    >
    </cards-page-filters>

    <el-row style="margin-top: 25px">
      <el-col :span="12">
        <div class="chart-name">Постановка/корректировка целей</div>
        <home-chart
          :stages="['plan', 'correction']"
          :filters="filters"
        ></home-chart>
      </el-col>
      <el-col :span="12">
        <div class="chart-name">Подведение итогов</div>
        <home-chart
          :stages="['assessment']"
          :filters="filters"
        ></home-chart>
      </el-col>
    </el-row>

  </div>
</template>

<script>

import {Chart} from 'highcharts-vue'
import HomeChart from "@/components/home/HomeChart.vue";
import CardsPageFilters from "@/componentsCompany/cherkizovo/CardsPageFilters";

export default {
  name: "home-charts",
  components: {CardsPageFilters, HomeChart, highcharts: Chart},

  props: {},
  computed: {},

  data() {
    return {
      loading: false,
      filters: {
        years: [this.getDefaultYear()]
      },

      counters: {},

    }
  },
  mounted() {

  },
  watch: {},
  methods: {
    getDefaultYear() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const march10 = new Date(currentYear, 2, 10);

      return now < march10 ? currentYear - 1 : currentYear;
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/css/project-variables";

.home-charts-container{

  .chart-name {
    text-align: center;
    font-weight: bold;
  }
}

</style>